import { connect } from 'react-redux';
import VideoSchema from './video-schema.component';
const mapStateToProps = (state, ownProps) => {
    const props = Object.assign({},ownProps,{
        "imageServer": state.WebView.medscape.config.imageServer
    })

    return props;
};
const mapDispatchToProps = dispatch => {
    return {

    }
};

const VideoSchemaModule = connect(mapStateToProps, mapDispatchToProps)(VideoSchema);
export default VideoSchemaModule;